import React from 'react';
import { useUser } from '../../context/UserContext.jsx';
import { can } from '../../permissions/access.js';
import { PERMISSIONS } from '../../permissions/permissions.js';

const DISCIPLINES = [
  { key: 'rakenne', label: 'Rakenne' },
  { key: 'lvi',     label: 'LVI'     },
  { key: 'sahko',   label: 'Sähkö'   },
];

const STATE_CONFIG = {
  ready:     { icon: 'bi-shield-fill-check',       color: 'var(--bs-success)', title: 'Valmis — klikkaa merkitäksesi keskeneräiseksi'    },
  not_ready: { icon: 'bi-shield-fill-exclamation', color: 'var(--bs-warning)', title: 'Ei valmis — klikkaa merkitäksesi valmiiksi' },
};

export default function SectionReadinessButtons({ readiness = {}, onChange }) {
  const { localUser } = useUser();
  const canEdit = can(localUser, PERMISSIONS.REPORTS.EDIT);

  const toggle = (key) => {
    if (!canEdit) return;
    const next = (readiness[key] ?? 'not_ready') === 'ready' ? 'not_ready' : 'ready';
    onChange(key, next);
  };

  return (
    <div className="d-flex align-items-center gap-3">
      {DISCIPLINES.map(({ key, label }) => {
        const state = readiness[key] ?? 'not_ready';
        const { icon, color, title } = STATE_CONFIG[state];
        return (
          <span
            key={key}
            className="section-state-toggle"
            title={title}
            onClick={() => toggle(key)}
            style={{ cursor: canEdit ? 'pointer' : 'default', flexDirection: 'column', alignItems: 'center', gap: '0.15rem' }}
          >
            <i className={`bi ${icon} fs-4`} style={{ color, textShadow: '0 0 3px rgba(0,0,0,0.15)' }} />
            <span style={{ fontSize: '0.72rem', color: '#555', fontWeight: 500 }}>{label}</span>
          </span>
        );
      })}
    </div>
  );
}
